export const TradeTypes = {
  BUY: "BUY",
  SALE: "SALE",
};

export const Lookups = {
  Algorithms: "Algorithms",
  // Back Testing page: this app's algorithms + IN.Core TrendData algorithms it can score (e.g. SR).
  BackTestAlgorithms: "BackTestAlgorithms",
  // Screening page: this app's algorithms + IN.Core TrendData algorithms it can live-score (e.g. SR).
  ScreeningAlgorithms: "ScreeningAlgorithms",
  MomentumAlgorithms: "MomentumAlgorithms",
  Countries: "Countries",
  BackYears: "BackYears",
};

export const TradeStatus = {
  Error: "Error",
  ReadyToStart: "ReadyToStart",
  Running: "Running",
  Stopped: "Stopped",
  Completed: "Completed",
  // Market shut: the desk still renders, with a warning, so a run can be scheduled.
  OutsideWindow: "OutsideWindow",
};

export const PredictionStatus = {
  Error: "Error",
  ReadyToStart: "ReadyToStart",
  Running: "Running",
  Stopped: "Stopped",
  OutsideWindow: "OutsideWindow",
};
